import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { BackgropComponent } from '../../base/backgrop/backgrop.component';
import { CommentComponent } from '../../base/comment/comment.component';
import { GameStateService } from '../../../../services/game-state/game-state.service';
import { Container, Graphics } from 'pixi.js';


export enum OnboardingModalType {
  START = 0,
  TRAP = 1,
}
export interface ModalData {
  title: string;
  desc: string;
  action: string;
}

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent implements AfterViewInit {
  @Input()
  modalType: OnboardingModalType;
  @Output()
  close: EventEmitter<void> = new EventEmitter();

  data: ModalData[] = [{
    title: 'Исследуй парк',
    desc: 'Нажимай на дорогу, чтобы двигаться по парку, и на персонажей — чтобы общаться и посещать аттракционы. Пройди все аттракционы, чтобы составить главное резюме своей жизни.',
    action: `Нажми,&nbsp;чтобы&nbsp;продолжить`
  }, {
    title: 'Ветер перемен',
    desc: 'Здесь, как и в жизни: если ничего не делать, выбор профессии может стать случайным. Но&nbsp;если действовать активно, ты сможешь сам выбрать&nbsp;направление, которое&nbsp;тебе&nbsp;действительно&nbsp;интересно.<br><br>Быстро нажимай на экран и двигайся вперёд!',
    action: `Нажми,&nbsp;чтобы&nbsp;продолжить`
  }];

  currentModalData = this.data[0];

  overlay:Graphics;
  prevz;
  constructor(private cdr: ChangeDetectorRef,
    
        private state: GameStateService
  ) {}

  ngAfterViewInit(): void {
    
    this.currentModalData = this.data[this.modalType];
    this.cdr.detectChanges();


    
    this.addOverlayToField(this.state.containers.mainField);
    const pl = this.state.player?.spine;
    this.prevz = pl?.zIndex;
    if (pl)
    pl.zIndex = 1001;
  }

  closeModal(event: PointerEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.close.emit();
  }

  ngOnDestroy(): void {
    
    this.state.containers.mainField.removeChild(this.overlay);
    const pl = this.state.player?.spine;
    if (pl)
    pl.zIndex = this.prevz;
  }


  private addOverlayToField(field: Container) {
    this.overlay = new Graphics();

    this.overlay
      .rect(0, 0, field.width, field.height)
      .fill({
        color: 0x000000,
        alpha: 0.6,
      });

    this.overlay.zIndex = 1000;

    field.addChild(this.overlay);

  }
}
